/**
 * Common components for backward compatibility with Medusa UI
 *
 * These are simple wrappers around HTML elements to maintain compatibility
 * with the previous Medusa UI components. For new code, prefer using:
 * - Semantic HTML directly (<h1>, <p>, <div>, etc.)
 * - shadcn/ui components from @/components/ui/*
 */

// Re-export utilities
export { cn } from "@/lib/utils"

// Simple HTML wrappers
export { Text } from "./text"
export { Heading } from "./heading"
export { Container } from "./container"

// Re-export shadcn/ui components for convenience
export { Button } from "@/components/ui/button"
export { Badge } from "@/components/ui/badge"
export { Input } from "@/components/ui/input"
export { Label } from "@/components/ui/label"
export { Checkbox } from "@/components/ui/checkbox"
export { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
} from "@/components/ui/table"
export { Toaster } from "@/components/ui/toaster"
export { toast, useToast } from "@/lib/hooks/use-toast"

// Icon replacements (map Medusa icons to lucide-react)
export { Loader2 as Spinner } from "lucide-react"
export { CheckCircle as CheckCircle } from "lucide-react"

// IconButton is just a button alias for backward compatibility
export { Button as IconButton } from "@/components/ui/button"

// IconBadge is just a badge alias for backward compatibility
export { Badge as IconBadge } from "@/components/ui/badge"

// useToggleState hook for handling boolean toggle state
export { default as useToggleState, type StateType } from "@/lib/hooks/use-toggle-state"
